// extracted by mini-css-extract-plugin
export default {"navigation":"Navbar_navigation__KRFQf","btn":"Navbar_btn__pls7q"};